"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnnouncePopup = void 0;
const mithril_1 = __importDefault(require("mithril"));
const app_1 = require("../../../app");
const modal_1 = require("../../../widgets/modal");
exports.AnnouncePopup = {
    active: false,
    announces: [],
    show(bookingId) {
        exports.AnnouncePopup.active = true;
        app_1.App.get(`/bookings/${bookingId}/announces`).then((list) => {
            exports.AnnouncePopup.announces = list;
            mithril_1.default.redraw();
        });
        mithril_1.default.redraw();
    },
    viewAnnounces() {
        return exports.AnnouncePopup.announces.map(ann => {
            let contentHtml = ann.content.split(/\n/g).map(str => [mithril_1.default.trust(str), (0, mithril_1.default)("br")]);
            return (0, mithril_1.default)(".content", (0, mithril_1.default)("h3", ann.title), (0, mithril_1.default)("p", contentHtml), (0, mithril_1.default)("hr"));
        });
    },
    view() {
        return (0, modal_1.modalCard)({
            content: [
                "Une note est disponible pour votre réservation: ",
                (0, mithril_1.default)("hr"),
                this.viewAnnounces()
            ],
            foot: (0, mithril_1.default)("button.button", { onclick: function () { exports.AnnouncePopup.active = false; } }, "Ok"),
            onClose: () => { exports.AnnouncePopup.active = false; },
            title: "Une information importante est disponible",
            isActive: exports.AnnouncePopup.active
        });
    }
};
let w = window;
w.Ann = exports.AnnouncePopup;
